import apis from "@/api";

function setBase(state, name, { api, params }) {
  if (sessionStorage.getItem(name)) {
    state[name] = JSON.parse(sessionStorage.getItem(name));
    return state[name];
  } else {
    return apis[api](params).then(res => {
      if (res.status) {
        state[name] = res.data;
        sessionStorage.setItem(name, JSON.stringify(res.data));
        return res.data;
      }
    });
  }
}

export default {
  namespaced: true,
  state: {
    baseInfo: {},
    tree: [],
    navbar: {},
    notice_cid_7: [],
    notice_cid_3: [],
    helper: []
  },
  actions: {
    getBaseInfo({ state }) {
      setBase(state, "baseInfo", { api: "GET_SETTINGINFO" });
    },
    getNotice({ state }, payload) {
      const name = `notice_cid_${payload.articleCategoryId}`;
      setBase(state, name, { api: "GET_ARTICLESIMPLE", params: payload });
    },
    getHelper({ state }) {
      return setBase(state, 'helper', { api: "GET_NOTICELIST" });
    },
    getNavbar({ state }) {
      setBase(state, 'navbar', { api: "GET_NAVBAR" });

    },
    getTree({ state }) {
      setBase(state, 'tree', { api: "GET_GOODSTREE" });
    },
    refreshUserInfo() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo")) || "";
      if (!userInfo) return;
      if (sessionStorage.getItem("refreshUserInfo")) return;
      apis.GET_USERDETAIL().then(res => {
        if (res.status) {
          const info = {
            account: res.data.info.account,
            avatar: res.data.info.avatar,
            id: res.data.info.id,
            nickname: res.data.info.nickname,
            passwordSimple: res.data.info.passwordSimple
          };
          const token = res.data.token;
          this.commit("LOGIN", { info, token });
          sessionStorage.setItem("refreshUserInfo", true);
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/sessionData.js